import React from 'react';
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';

import { GRAY, GRAY_LIGHT } from '../constants/Colors';
import partsCategories from '../partsCategories';
import { CategoryID } from '../types/PartsCategory';
import Row from './Row';
import ScrollViewWithFadeIndicators from './ScrollViewWithFadeIndicators';
import Subtitle from './Subtitle';

const HEIGHT = 32;

const PartCategoryItem = ({ title, onPress, selected }) => (
  <TouchableOpacity
    style={{
      height: HEIGHT,
      borderRadius: HEIGHT / 2,
      backgroundColor: selected ? 'white' : GRAY,
      justifyContent: 'center',
      marginVertical: 5,
      paddingHorizontal: 12,
    }}
    onPress={onPress}
  >
    <Text
      style={{
        color: selected ? 'black' : 'white',
        marginBottom: 2,
        fontSize: 13,
      }}
    >
      {title}
    </Text>
  </TouchableOpacity>
);

type Props = {
  onCategorySelected: (categoryId: CategoryID) => void;
  selectedCategoryID: CategoryID;
};

export default ({ onCategorySelected, selectedCategoryID }: Props) => (
  <View style={styles.container}>
    <Subtitle>Choose a part to customize</Subtitle>
    <View style={{ height: 8 }} />
    <ScrollViewWithFadeIndicators>
      {partsCategories.map((folder, i) => (
        <React.Fragment key={folder.name}>
          <PartCategoryItem
            title={`${folder.name.split('. ')[1]} (${folder.children.length})`}
            onPress={() => onCategorySelected(folder.name)}
            selected={selectedCategoryID === folder.name}
          />
          {i !== partsCategories.length - 1 && <View style={{ width: 5 }} />}
        </React.Fragment>
      ))}
    </ScrollViewWithFadeIndicators>
  </View>
);

const styles = StyleSheet.create({
  container: {},
  subtitle: {
    textTransform: 'uppercase',
    color: GRAY_LIGHT,
    fontWeight: 'bold',
    fontSize: 12,
  },
});
